































































































































































































import NonCommodityRegistrationWidget from '@/components/widgets/NonCommodityRegistrationWidget.vue';
import Component from 'vue-class-component';
import vSelect from 'vue-select';
import _ from 'lodash';
import Format from '@/interfaces/Format';
import IocContainer from '@/container/IocContainer';
import SERVICES from '@/container/Services';
import NonCommodityProductFacade from '@/models/NonCommodityProductFacade';

const formatProvider = IocContainer.get<Format>(SERVICES.FORMAT);

@Component({
  components: {
    'v-select': vSelect
  }
})
export default class RegistrationWidget extends NonCommodityRegistrationWidget {
  protected fieldIdentifiers: string[] = ['license-plate'];
  protected fieldIdentifiersMandatory: string[] = ['license-plate'];

  created(): void {
    this.linkThgConfigExtendedData();
  }

  public getPremiumForYearFormatted(year: string): string {
    return formatProvider.euro()(this.getPremiumForYear(year)) + ' ' + this.$t('noncommodity.product.currency');
  }

  public get getPremiumForYear() {
    return (year: string) => {
      let premium: number = 0;
      if (this.thgConfig.isCustomerTypeBusiness) {
        premium = this.nonCommodityProduct.getBasePriceForYear(this.$store.getters.getSelectedVehicleType, year);
      } else {
        premium = this.nonCommodityProduct.getBasePriceBruttoForYear(this.$store.getters.getSelectedVehicleType, year);
      }
      return premium;
    };
  }

  get vehicleTypes(): Array<{ id: string; label: string | any }> {
    const possibleVehicleTypes = NonCommodityProductFacade.getEnabledVehicleTypesForProduct(
      this.store.state.nonCommodityProductData,
      this.thgConfig.selectedYear
    );
    let vehicleTypes: Array<{ id: string; label: string | any }> = [];
    for (let vehicleType of possibleVehicleTypes) {
      vehicleTypes.push({
        id: vehicleType.identifier,
        label: this.$t(vehicleType.class) + ' - ' + this.$t(vehicleType.title)
      });
    }
    return vehicleTypes;
  }

  protected getVehicleTypeById(id: string): { id: string; label: string | any } {
    for (let vehicleType of this.vehicleTypes) {
      if (vehicleType.id === id) {
        return vehicleType;
      }
    }
    return { id: '', label: '' };
  }

  get vehicleType(): { id: string; label: string | any } {
    const typeId: string = this.thgConfig.getExtendedDataFieldValue(this.thgConfig.extendedDataKeyVehicleClasses);
    return this.getVehicleTypeById(typeId);
  }

  set vehicleType(value: { id: string; label: string | any }) {
    this.thgConfig.setExtendedDataFieldValue(this.thgConfig.extendedDataKeyVehicleClasses, value.id);
  }

  get licensePlate(): string {
    return this.thgConfig.getExtendedDataFieldValue(this.thgConfig.extendedDataKeyLicensePlates);
  }

  set licensePlate(value: string) {
    this.thgConfig.setExtendedDataFieldValue(this.thgConfig.extendedDataKeyLicensePlates, value);
  }

  get columnSizeClass(): string {
    const countSelectedYears = this.thgConfig.selectedYearArray.length;
    if (countSelectedYears > 1) {
      return 'col-lg-3';
    }
    return 'col-lg-4';
  }

  get exampleImageLink(): string {
    switch (process.env.VUE_APP_ENVIRONMENT) {
      case 'elli-thg-audi':
        return 'Audi-Fahrzeugschein-Beispiel.png';
      case 'elli-thg-cupra':
        return 'Cupra-Fahrzeugschein-Beispiel.png';
      case 'elli-thg-skoda':
        return 'Skoda-Fahrzeugschein-Beispiel.png';
      case 'elli-thg-vwfs':
        return 'VWFS-Fahrzeugschein-Beispiel.png';
      case 'elli-thg-vw':
        return 'VW-Fahrzeugschein-Beispiel.png';
      default:
        return 'fahrzeugschein.png';
    }
  }

  get isStepComplete(): boolean {
    return this.licensePlate.length > 0 && this.registrationFileFront.isUploaded;
  }
}
